import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "slider-gallery__main-wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "slider-gallery__thumbs-wrapper"
}
const _hoisted_6 = ["src"]

import { Swiper, SwiperSlide } from 'swiper/vue';
    import { Pagination, Thumbs, EffectFade } from 'swiper/modules';
    import { Swiper as SwiperType } from 'swiper/types';
    import { computed, ref } from 'vue';
    import NavChevronLeftIcon from '../commons/icons/NavChevronLeftIcon.vue';
    import { cardSettingsStore } from '@/store/modules/CardSettings';
    import { galleryStore } from '@/store/modules/Gallery';
    import { DESKTOP_TOP, XL_BOTTOM } from '@/constants/sizes';
    import 'swiper/css';
    import 'swiper/css/pagination';
    import 'swiper/css/thumbs';
    import 'swiper/css/effect-fade';

    
    export interface SliderGalleryProps {
        images: string[];
        imageFitContain?: boolean;
        mode?: 'house' | 'plot' | 'full';
        defaultActiveIndex?: number;
    }

export default /*@__PURE__*/_defineComponent({
  __name: 'SliderGallery',
  props: {
    images: {},
    imageFitContain: { type: Boolean },
    mode: {},
    defaultActiveIndex: {}
  },
  setup(__props: any) {

    const props = __props;

    const activeImageIndex = ref(props.defaultActiveIndex || 0);

    const mainSwiper = ref<SwiperType | null>(null);
    const thumbsSwiper = ref<SwiperType | null>(null);

    const modules = [Thumbs, Pagination];
    const mainModules = [...modules, EffectFade];

    const hasThumbnails = computed(
        () =>
            (props.mode === 'plot' || props.mode === 'house') &&
            props.images.length > 1,
    );

    const autoHeight = computed(() => props.mode === 'full');

    const thumbs = computed(() =>
        hasThumbnails
            ? {
                  swiper: thumbsSwiper.value,
              }
            : {},
    );

    const isClickable = computed(() => props.mode !== 'full');

    const setThumbsSwiper = (swiper: SwiperType) => {
        thumbsSwiper.value = swiper;
    };

    const setMainSwiper = (swiper: SwiperType) => {
        mainSwiper.value = swiper;
    };

    const onMainImageClick = () => {
        galleryStore.SET_IMAGES(props.images);
        galleryStore.SET_ACTIVE_INDEX(activeImageIndex.value);
        galleryStore.SET_SHOW_MODAL(true);
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["slider-gallery", _ctx.mode && `slider-gallery--mode-${_ctx.mode}`])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Swiper), {
          class: "slider-gallery__main",
          "slides-per-view": 1,
          thumbs: thumbs.value,
          modules: mainModules,
          pagination: {
                        clickable: true,
                        bulletClass: 'slider-gallery__pagination-bullet',
                        bulletActiveClass:
                            'slider-gallery__pagination-bullet--active',
                    },
          autoHeight: autoHeight.value,
          initialSlide: activeImageIndex.value,
          effect: "fade",
          onSwiper: setMainSwiper,
          onSlideChange: _cache[1] || (_cache[1] = ($event: any) => (activeImageIndex.value = $event.realIndex))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, i) => {
              return (_openBlock(), _createBlock(_unref(SwiperSlide), null, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: _normalizeClass(["slider-gallery__main-slide", {
                                'slider-gallery__main-slide--fit-contain':
                                    _ctx.imageFitContain,
                                'slider-gallery__main-slide--clickable':
                                    isClickable.value,
                            }]),
                    src: image || '',
                    alt: "",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (isClickable.value && onMainImageClick()))
                  }, null, 10, _hoisted_2)
                ]),
                _: 2
              }, 1024))
            }), 256))
          ]),
          _: 1
        }, 8, ["thumbs", "autoHeight", "initialSlide"]),
        (_ctx.mode === 'full' && _ctx.images.length > 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "slider-gallery__full-nav-btn slider-gallery__full-nav-btn--prev",
              disabled: mainSwiper.value?.isBeginning,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (mainSwiper.value?.slidePrev()))
            }, [
              _createVNode(NavChevronLeftIcon, { class: "slider-gallery__full-nav-btn-icon" })
            ], 8, _hoisted_3))
          : _createCommentVNode("", true),
        (_ctx.mode === 'full' && _ctx.images.length > 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "slider-gallery__full-nav-btn slider-gallery__full-nav-btn--next",
              disabled: mainSwiper.value?.isEnd,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (mainSwiper.value?.slideNext()))
            }, [
              _createVNode(NavChevronLeftIcon, { class: "slider-gallery__full-nav-btn-icon" })
            ], 8, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      (hasThumbnails.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_unref(Swiper), {
              class: "slider-gallery__thumbs",
              spaceBetween: 20,
              slidesPerView: 3,
              watchSlidesProgress: true,
              modules: modules,
              initialSlide: activeImageIndex.value,
              onSwiper: setThumbsSwiper
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, i) => {
                  return (_openBlock(), _createBlock(_unref(SwiperSlide), null, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        class: "slider-gallery__thumbs-slide",
                        src: image || '',
                        alt: ""
                      }, null, 8, _hoisted_6)
                    ]),
                    _: 2
                  }, 1024))
                }), 256))
              ]),
              _: 1
            }, 8, ["initialSlide"]),
            (_ctx.images.length > 3)
              ? (_openBlock(), _createBlock(NavChevronLeftIcon, {
                  key: 0,
                  class: _normalizeClass(["slider-gallery__nav-btn slider-gallery__nav-btn--prev", 
                        thumbsSwiper.value?.isBeginning &&
                        'slider-gallery__nav-btn--disabled'
                    ]),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (thumbsSwiper.value?.slidePrev()))
                }, null, 8, ["class"]))
              : _createCommentVNode("", true),
            (_ctx.images.length > 3)
              ? (_openBlock(), _createBlock(NavChevronLeftIcon, {
                  key: 1,
                  class: _normalizeClass(["slider-gallery__nav-btn slider-gallery__nav-btn--next", 
                        thumbsSwiper.value?.isEnd &&
                        'slider-gallery__nav-btn--disabled'
                    ]),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (thumbsSwiper.value?.slideNext()))
                }, null, 8, ["class"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})